import { render, staticRenderFns } from "./contract-rents.vue?vue&type=template&id=ee55e6f0&scoped=true"
import script from "./contract-rents.vue?vue&type=script&lang=js"
export * from "./contract-rents.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=ee55e6f0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee55e6f0",
  null
  
)

export default component.exports